export const getCssVar = (v: string, fallback = '') => {
    const source = document.getElementById('app')

    if (source) {
        return getComputedStyle(source)
            .getPropertyValue(v).trim() || fallback
    }

    return fallback
}
